import React from 'react';
import {Field} from 'redux-form';
import CustomTextField from '../Input/CustomTextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import EmailIcon from '@material-ui/icons/Email';
import {compose} from 'redux';
import {useTranslation} from 'react-i18next';
import {withStyles} from '@material-ui/core/styles';
import {SaveButton, SimpleForm} from '../../controlComponents';
import {endpointSendVerificationLetter, resourceCustomUsers} from '../../constants';
import {useDataProvider} from '../../fetchApi/dataProvider';
import {FETCH} from '../../fetchApi/types';
import {NotificationManager} from 'react-notifications';
import {RouteChildrenProps, withRouter} from 'react-router-dom';
import {Toolbar} from '@material-ui/core';

const styles = {
    form: {
        padding: '0 1em 1em 1em',
    },
    forgotPasswordButton: {
        textTransform: 'none',
        marginTop: '16px',
    },
};

interface SendVerificationLetterFormProps extends RouteChildrenProps {
    classes: Record<string, string>;
}

const CustomToolbar: React.FunctionComponent<Record<string, any>> = ({
    handleSubmitWithRedirect,
    ...rest
}) => {
    const {t: translate} = useTranslation();

    return (
        <Toolbar>
            <SaveButton
                noIcon
                fullWidth
                saveButtonLabel={translate('users.email.actions.send_again')}
                handleSubmitWithRedirect={handleSubmitWithRedirect}
                {...rest}
            />
        </Toolbar>
    );
};

const FormView: React.FunctionComponent<SendVerificationLetterFormProps> = ({
    classes,
    history,
}) => {
    const {t: translate} = useTranslation();
    const {dataProvider} = useDataProvider();

    const customSave = (values: Record<string, string>): void => {
        dataProvider(FETCH, `${resourceCustomUsers}/${endpointSendVerificationLetter}`, {email: values.email})
            .then(() => {
                NotificationManager.success(translate('users.email.notifications.send_success'));
                history.push('/');
            })
            .catch(e => {
                NotificationManager.error(e.message);
            });
    };

    return (
        <div className='rct-session-wrapper' style={{display: 'flex'}}>
            <div className='session-inner-wrapper' style={{alignSelf: 'center', width: '100%', transform: 'translate3d(0%, -10%, 0)'}}>
                <div className='container'>
                    <div className='row row-eq-height' style={{flexDirection: 'column'}}>
                        <div className='col-sm-7 col-md-7 col-lg-8'>
                            <div className='session-body text-center'>
                                <SimpleForm
                                    resource={resourceCustomUsers}
                                    save={customSave}
                                    form='send-verification-letter-form'
                                    toolbar={<CustomToolbar />}
                                >
                                    <div className={classes.form}>
                                        <p className='mb-0' style={{textAlign: 'left'}}>{translate('forgot_password.forgot_password_suggestion')}</p>
                                        <Field
                                            type='email'
                                            name='email'
                                            autoFocus
                                            label={translate('common.email')}
                                            component={CustomTextField}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position='end'>
                                                        <EmailIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                            validate={(email: string): string | undefined => {
                                                if (!email || !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
                                                    return ('Email is invalid');
                                                }

                                                return undefined;
                                            }}
                                            variant='outlined'
                                        />
                                    </div>
                                </SimpleForm>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// @ts-ignore
const SendVerificationLetterForm: React.ComponentType<Record<string, unknown>> = compose(
    withRouter,
    // @ts-ignore
    withStyles(styles)
)(FormView);

export default SendVerificationLetterForm;